import axios from "axios";
import { alertErrorText } from "helpers/notification";
import store from "../store"

const DEBUG = false;

if (DEBUG) {
  axios.interceptors.request.use(request => {  
    return request;
  });

  axios.interceptors.response.use(response => {    
    return response;
  });
}

axios.interceptors.request.use(
  request => {
    return request;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

export const API = {
  buildUrl: endpoint => {
    return process.env.REACT_APP_API_ROOT + `/${endpoint}`;
  },
  post: async (endpoint, data) => {
    const url = API.buildUrl(endpoint);

    const state = store.getState();
    const { authorization, appId, sessionId, userName } = state.common;

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        Authorization: authorization,
        AppId: appId,
        SessionId: sessionId,
        UserName: userName,
      },
      data,
      timeout: 900000,
    };

    let response;
    let noBackdrop =
    "Query/GetQueryStatuses" ;

    try {
      
      if (!(noBackdrop.indexOf(endpoint) > -1)) {  
        window.dispatchEvent(new Event("backdropOpenStartEvent"));
      }  
      response = await axios(url, requestOptions);
    } catch (e) {
      if(e.response.status == 401)
      {        
        let locationPathname = localStorage.getItem('locationPathname');
        localStorage.clear();
        if (locationPathname != null) {         
          localStorage.setItem("locationPathname", locationPathname);
        }
        
        window.location.replace("/authentication/sign-in");  
        return false;
      }        
      else
      {
        alertErrorText("'" | (url + "'") | "  adresi bulunamadı");
      }        
    } finally {  
      if (!(noBackdrop.indexOf(endpoint) > -1)) {   
        window.dispatchEvent(new Event("backdropOpenEndEvent"));
      }
    }

    if(response === undefined) return false;
    if (response.status !== 200) return false;
    
    if (response.data) {
      return response;
    } else {
      return false;
    }
  },
};